import React, { Component } from 'react';
import AnswerButton from '../AnswerButton/AnswerButton';

import './styles.scss';

class TextCard extends Component {
  render() {
    const { showAnswerButtons, topic } = this.props;

    return (
      <div className={`text-card ${this.props.className}`}>
        <div className="text-body">
          {this.props.children}
        </div>
        {
          showAnswerButtons &&
          <div className="answer-button-footer">
            <AnswerButton topic={topic} type='yes' />
            <AnswerButton topic={topic} type='no' />
          </div>
        }
      </div>
    );
  }
}

export default TextCard;

TextCard.defaultProps = {
  showAnswerButtons: false
}
